import { Box, FloraTypography } from '@grupoboticario/flora-react'

import RichTextEditor from '@/components/RichTextEditor'
import { getHtmlTextLength } from '@/utils/htmlHelpers/htmlHelpers'

import {
  descriptionEditorContainerStyle,
  characterCountStyle,
  DESCRIPTION_EDITOR_HEIGHT,
  MAX_DESCRIPTION_LENGTH
} from './DescriptionEditor.styles'

const DescriptionEditor = ({ descricaoRef, description = '', onBlur, isReadOnly = false }) => {
  return (
    <Box css={descriptionEditorContainerStyle}>
      <RichTextEditor
        editorRef={descricaoRef}
        isReadOnly={isReadOnly}
        minHeight={DESCRIPTION_EDITOR_HEIGHT}
        onBlur={onBlur}
        placeholder="Descrição: *  Resumo do Evento"
      />

      <FloraTypography css={characterCountStyle} fontSize="exceptionsRestricted">
        {getHtmlTextLength(description || '')}/{MAX_DESCRIPTION_LENGTH}
      </FloraTypography>
    </Box>
  )
}

export default DescriptionEditor
